import { render, staticRenderFns } from "./CollapseItem.vue?vue&type=template&id=c4784502"
import script from "./CollapseItem.vue?vue&type=script&lang=js"
export * from "./CollapseItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports